import { Component, OnInit, OnDestroy } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { WeGoConfig, IAPIResponse } from "../../shared/config";
import { Observable } from "rxjs/Observable";
import { TranslateService } from "../../shared/translate/index";

@Component({
  selector: "wego-personprofile-success",
  template: require('../views/personprofilesuccess.component.html'),
  styles: [
    `.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`
  ]
})
export class PersonProfileSuccessComponent implements OnInit, OnDestroy {
  errorMessage: any;
  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.translate.setDetectedLang();
  }

  ngOnDestroy() {
    console.log("ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/personprofile/componets/personprofilesuccess.componets.ts